module.exports = __webpack_public_path__ + "static/media/Neighbour.5a0b2f79.mp4";